/* eslint-disable import/prefer-default-export */
export const getCurrentUserName = state => state.users.userName;
export const getCurrentUserId = state => state.users.userId;
